<template>
  <v-dialog :value="dialog" persistent max-width="700" @click:outside="$emit('close')">
    <v-card>
      <v-card-title class="text-h5"> Communication Channels </v-card-title>
      <div class="Channels__container">
        <div class="Channels__channel">
          <div class="Channels__channel__title">
            <div>
              <img
                  :src="`${publicPath}/icons/slackIcon.svg`"
                  alt=""
                  height="20"
                  style="vertical-align: middle; margin-right: 15px"
              />
            </div>
            <div style="font-weight: bold; margin-top: 1px">Slack</div>
          </div>
          <div>
            <v-btn class="Channels__channel__expand" @click="goToChannelSessions('slack')" color="primary">VIEW SESSIONS</v-btn>
            <v-btn icon class="Channels__channel__expand" @click="expandChannelType('slack')"><v-icon>{{ expand === 'slack' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
          </div>
        </div>
        <div class="Channels__keys" v-if="expand === 'slack' && !keysLoading">
          <div class="Channels__keys__item" v-for="apiKey in apiKeys"  :key="apiKey.id">
            <div class="Channels__keys__item__key">{{ apiKey.key }}</div>
            <div>
              <v-btn icon><v-icon color="blue">mdi-content-copy</v-icon></v-btn>
              <v-btn icon @click="deleteKey(apiKey.id)" :loading="deleteLoading"><v-icon color="red">mdi-delete</v-icon></v-btn>
            </div>
          </div>
          <div class="Channels__keys__generate">
            <v-btn icon @click="generateNewApiKey('slack')" :loading="generateLoading"><v-icon small>mdi-plus</v-icon></v-btn>
          </div>
        </div>

        <v-progress-circular
            :size="25"
            :width="2"
            color="primary"
            indeterminate
            v-if="keysLoading"
        />
      </div>


      <div class="Channels__container">
        <div class="Channels__channel">
          <div class="Channels__channel__title">
            <div>
              <img
                  :src="`${publicPath}/icons/twilio.svg`"
                  alt=""
                  height="20"
                  style="vertical-align: middle; margin-right: 15px"
              />
            </div>
            <div style="font-weight: bold; margin-top: 1px">SMS (Twilio)</div>
          </div>
          <div>
          <v-btn class="Channels__channel__expand" @click="goToChannelSessions('sms')" color="primary">VIEW SESSIONS</v-btn>
          <v-btn icon class="Channels__channel__expand" @click="expandChannelType('sms')"><v-icon>{{ expand === 'sms' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
          </div>
        </div>
        <div class="Channels__keys" v-if="expand === 'sms' && !twilioChannelInfoLoading">
          <v-autocomplete
              outlined
              dense
              v-model="authenticationId"
              :items="authentications"
              item-text="name"
              item-value="id"
              label="Authentication"
              @click:append-outer="getTwilioAuth"
              :append-outer-icon="
              fetchCredentialsLoading ? 'mdi-loading mdi-spin' : 'mdi-reload'
            "
              clearable
          ></v-autocomplete>
          <v-text-field
              outlined
              dense
              label="Phone Number"
              v-model="number"
          />
          <v-btn @click="updateOrCreateTwilioChannel" :loading="updateTwilioChannelInfoLoading" primary outlined>
            Save
          </v-btn>
        </div>

        <v-progress-circular
            :size="25"
            :width="2"
            color="primary"
            indeterminate
            v-if="twilioChannelInfoLoading"
        />
      </div>

      <div class="Channels__container">
        <div class="Channels__channel">
          <div class="Channels__channel__title">
            <div>
              <v-icon color="green" style="margin-right: 10px; margin-left: -3px">
                mdi-arrow-down-thick
              </v-icon>
            </div>
            <div style="font-weight: bold; margin-top: 1px">Incoming Event</div>
          </div>
          <div>
          <v-btn class="Channels__channel__expand" @click="goToChannelSessions('incoming_event')" color="primary">VIEW SESSIONS</v-btn>
          <v-btn icon class="Channels__channel__expand" @click="expandChannelType('incoming_event')"><v-icon>{{ expand === 'incoming_event' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
          </div>
        </div>
        <div class="Channels__keys" v-if="expand === 'incoming_event' && !incomingEventChannelInfoLoading">
          <v-autocomplete
            outlined
            dense
            v-model="authenticationId"
            :items="authentications"
            item-text="name"
            item-value="id"
            label="Authentication"
            @click:append-outer="getIncomingEventAuth"
            :append-outer-icon="
              fetchCredentialsLoading ? 'mdi-loading mdi-spin' : 'mdi-reload'
            "
            clearable
          ></v-autocomplete>
          <v-text-field
            outlined
            dense
            label="Session Identifier Path"
            v-model="sessionIdentifierPath"
          />
          <mustache-template
            label="Prompt Template"
            class="mr-2"
            :value="incomingEventPromptTemplate"
            @input="(val) => incomingEventPromptTemplate = val"
            :singleLine="false" />

          <p v-if="incomingEventId">
            Send POST request on incoming event endpoint:
            <span class="Activators__endpoint"
            >{{
                `https://${domain}/proxy/ai/incoming-event/run/${incomingEventId}?x-external-api-key=YOUR_KEY_HERE`
              }}
          </span>
          </p>

          <v-btn @click="updateOrCreateIncomingEventChannel" :loading="updateIncomingEventChannelInfoLoading" primary outlined>
            Save
          </v-btn>
        </div>

        <v-progress-circular
          :size="25"
          :width="2"
          color="primary"
          indeterminate
          v-if="incomingEventChannelInfoLoading"
        />
      </div>

      <div class="Channels__container">
        <div class="Channels__channel">
          <div class="Channels__channel__title">
            <div>
              <img
                :src="`${publicPath}/icons/podium.svg`"
                alt=""
                height="20"
                style="vertical-align: middle; margin-right: 15px"
              />
            </div>
            <div style="font-weight: bold; margin-top: 1px">Podium</div>
          </div>
          <v-btn icon class="Channels__channel__expand" @click="expandChannelType('podium')"><v-icon>{{ expand === 'podium' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
        </div>
        <div class="Channels__keys" v-if="expand === 'podium' && !podiumChannelInfoLoading">
          <v-autocomplete
            outlined
            dense
            v-model="authenticationId"
            :items="authentications"
            item-text="name"
            item-value="id"
            label="Authentication"
            @click:append-outer="getPodiumAuth"
            :append-outer-icon="
              fetchCredentialsLoading ? 'mdi-loading mdi-spin' : 'mdi-reload'
            "
            clearable
          ></v-autocomplete>
          <mustache-template
            label="Prompt Template"
            class="mr-2"
            :value="podiumPromptTemplate"
            @input="(val) => podiumPromptTemplate = val"
            :suggestions="podiumPromptSuggestions"
            :singleLine="false" />

          <p v-if="podiumId">
            Webhook URL:
            <span class="Activators__endpoint"
            >{{
                `https://${domain}/proxy/ai/podium/webhook/${this.workspace.id}`
              }}
          </span>
          </p>

          <v-btn @click="updateOrCreatePodiumChannel" :loading="updatePodiumChannelInfoLoading" primary outlined>
            Save
          </v-btn>
        </div>

        <v-progress-circular
          :size="25"
          :width="2"
          color="primary"
          indeterminate
          v-if="podiumChannelInfoLoading"
        />
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('close')"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import * as flat from 'flat';

const {
  mapGetters: communicationChannelsGetters,
  mapActions: communicationChannelsActions,
  mapMutations: communicationChannelsMutation,
} = createNamespacedHelpers('aiWorkspaceCommunicationChannel');

const {
  mapGetters: workspacesGetters,
} = createNamespacedHelpers('aiWorkspace');

const { mapGetters: credentialsGetters, mapActions: credentialsActions } =
    createNamespacedHelpers('credentials');

const { mapGetters: customerGetters } = createNamespacedHelpers('customer');

import constants from "@/util/constants";
import MustacheTemplate from '@/components/mustache/mustache-template.vue';

export default {
  name: 'AgentCommunicationChannels',
  components: { MustacheTemplate },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      publicPath: constants.isDevelopment ? "" : "",
      expand: 'none',
      authenticationId: null,
      number: null,
      incomingEventPromptTemplate: '',
      sessionIdentifierPath: '',
      incomingEventId: null,
      podiumPromptTemplate: '',
      podiumId: null,
    };
  },
  computed: {
    ...communicationChannelsGetters({
      apiKeys: 'API_KEYS',
      deleteLoading: 'DELETE_API_KEY_LOADING',
      generateLoading: 'GENERATE_API_KEY_LOADING',
      keysLoading: 'GET_API_KEYS_LOADING',
      twilioChannelInfo: 'TWILIO_CHANNEL_INFO',
      twilioChannelInfoLoading: 'TWILIO_CHANNEL_INFO_LOADING',
      updateTwilioChannelInfoLoading: 'UPDATE_TWILIO_CHANNEL_INFO_LOADING',
      incomingEventChannelInfo: 'INCOMING_EVENT_CHANNEL_INFO',
      incomingEventChannelInfoLoading: 'INCOMING_EVENT_INFO_LOADING',
      updateIncomingEventChannelInfoLoading: 'UPDATE_INCOMING_EVENT_CHANNEL_INFO_LOADING',
      podiumChannelInfo: 'PODIUM_CHANNEL_INFO',
      podiumChannelInfoLoading: 'PODIUM_INFO_LOADING',
      updatePodiumChannelInfoLoading: 'UPDATE_PODIUM_CHANNEL_INFO_LOADING',
    }),
    ...workspacesGetters({
      workspace: 'WORKSPACE',
    }),
    ...credentialsGetters({
      authentications: 'AUTHENTICATIONS',
      fetchCredentialsLoading: 'FETCH_CREDENTIALS_LOADING'
    }),
    ...customerGetters({
      selectedCustomer: 'SELECTED_CUSTOMER',
    }),
    domain() {
      return location.host;
    },
    podiumPromptSuggestions() {
      const sampleObject = {
        "data": {
          "uid": "",
          "body": "",
          "items": [],
          "sender": {
            "uid": []
          },
          "contact": {
            "uid": "",
            "name": "",
            "externalIdentifier": ""
          },
          "location": {
            "uid": "",
            "organizationUid": ""
          },
          "createdAt": "",
          "senderUid": "",
          "contactName": "",
          "conversation": {
            "uid": "",
            "channel": {
              "type": "",
              "identifier": ""
            },
            "startedAt": "",
            "assignedUserUid": ""
          },
          "attachmentUrl": "",
          "failureReason": ""
        },
        "metadata": {
          "eventUid": "",
          "eventType": ""
        }
      }
      const flatObj = flat.flatten(sampleObject);
      return Object.keys(flatObj)?.map((field) => { return { name: 'Object.'+field }});
    }
  },
  watch: {
    async 'selectedCustomer.customer_id'() {
      await this.fetchAuthentications();
    },
  },
  methods: {
    ...credentialsActions(['fetchAuthentications']),
    ...communicationChannelsActions([
      'getApiKeys',
      'generateApiKey',
      'deleteApiKey',
      'getTwilioChannelInfo',
      'updateOrCreateTwilio',
      'updateOrCreateIncomingEvent',
      'getIncomingEventChannelInfo',
      'updateOrCreatePodium',
      'getPodiumChannelInfo'
    ]),
    ...communicationChannelsMutation({
      setApiKeys: 'SET_API_KEYS',
    }),
    getTwilioAuth() {
      this.fetchAuthentications({ type: 'twilio' });
    },
    getIncomingEventAuth() {
      this.fetchAuthentications({ type: 'externalWorkflowActivator' });
    },
    getPodiumAuth() {
      this.fetchAuthentications({ type: 'podium' });
    },
    expandChannelType(channelType) {
      if(this.expand === channelType) {
        this.expand = 'none';
        return;
      }
      this.expand = channelType;

      switch (channelType) {
        case 'sms': {
          this.fetchTwilioChannelInfo();
          break;
        }
        case 'incoming_event': {
          this.fetchIncomingEventChannelInfo();
          break;
        }
        case 'podium': {
          this.fetchPodiumChannelInfo();
          break;
        }
        case 'slack': {
          this.getApiKeys({
            workspaceId: this.workspace.id,
            channelType,
          });
          break;
        }
        default: {
          break;
        }
      }
    },
    generateNewApiKey(channelType) {
      this.generateApiKey({
        workspaceId: this.workspace.id,
        channelType,
      });
    },
    updateOrCreateTwilioChannel() {
      this.updateOrCreateTwilio({
        workspaceId: this.workspace.id,
        number: this.number,
        authenticationId: this.authenticationId,
      })
    },
    updateOrCreateIncomingEventChannel() {
      this.updateOrCreateIncomingEvent({
        workspaceId: this.workspace.id,
        prompt: this.incomingEventPromptTemplate,
        sessionIdentifierPath: this.sessionIdentifierPath,
        authenticationId: this.authenticationId,
      })
    },
    updateOrCreatePodiumChannel() {
      this.updateOrCreatePodium({
        workspaceId: this.workspace.id,
        prompt: this.podiumPromptTemplate,
        authenticationId: this.authenticationId,
      })
    },
    async fetchTwilioChannelInfo() {
      this.fetchAuthentications({ type: 'twilio' });
      await this.getTwilioChannelInfo({ workspaceId: this.workspace.id });
      this.number = this.twilioChannelInfo?.number;
      this.authenticationId = this.twilioChannelInfo?.authenticationId;
    },
    async fetchIncomingEventChannelInfo() {
      this.fetchAuthentications({ type: 'externalWorkflowActivator' });
      await this.getIncomingEventChannelInfo({ workspaceId: this.workspace.id });
      this.incomingEventPromptTemplate = this.incomingEventChannelInfo?.prompt;
      this.authenticationId = this.incomingEventChannelInfo?.authenticationId;
      this.sessionIdentifierPath = this.incomingEventChannelInfo?.sessionIdentifierPath;
      this.incomingEventId = this.incomingEventChannelInfo?.id;
    },
    async fetchPodiumChannelInfo() {
      this.fetchAuthentications({ type: 'podium' });
      await this.getPodiumChannelInfo({ workspaceId: this.workspace.id });
      this.podiumPromptTemplate = this.podiumChannelInfo?.prompt;
      this.authenticationId = this.podiumChannelInfo?.authenticationId;
      this.podiumId = this.podiumChannelInfo?.id;
    },
    deleteKey(id) {
      this.deleteApiKey({
        workspaceId: this.workspace.id,
        id,
      });
      const keys = this.apiKeys.filter((key) => key.id !== id);
      this.setApiKeys(keys);
    },
    goToChannelSessions(channelType) {
      this.$router.push({ path: `/agents/${this.workspace.id}/communication-channels`, query: { channelType: channelType } })
    }
  },
};
</script>

<style lang="scss" scoped>
@import './communication-channels';
</style>
